/**
 * Initial state factory for the "home" Vuex module.
 *
 * Returned as a function (rather than a plain object) so Vuex gets a fresh,
 * unshared state tree per store instantiation.
 */
export default () => ({
  // Posts shown in the "Recommended"/"For All" feed tab
  recommendedPosts: [],
  //forYouPosts: [],
  // Suggested users to follow (people-you-may-know style widget)
  suggestedPosts: [],
  // Single post loaded for the post-detail view
  recommendedPost: [],
  // Posts shown in the "Following"/"For You" feed tab
  followingPosts: [],
  // Replies loaded for the currently viewed post (post-detail thread)
  replies: [],
  // Reference data for the reputation/reaction categories used when reacting to a post
  reputationCategories: null,
  // Result of the most recent createPost/updatePost action
  post: null,
  // Most recently created top-level post, kept until it shows up in a
  // server feed response so a feed refetch can re-inject it if the
  // backend hasn't indexed/ranked it yet (avoids the "post vanishes
  // until page refresh" race).
  lastCreatedPost: null,
  // Live clock tick used by relative-time displays ("2m ago"); advanced by
  // the startGlobalTimer action via the updateNow mutation.
  now: new Date(),
  // Legacy/other-user profile object (kept separate from usernameData below)
  profile: null,
  // Profile-by-username data for profile view
  usernameData: null,
  // Current user's own reply posts (profile "Replies" tab)
  userReplies: [],
  // Current user's own reposts (profile "Reposts" tab)
  userReposts: [],
  // Current user's own top-level posts (profile "Posts" tab)
  onlyUserPosts: [],
  // Generic loading flag toggled by setUpdateStatus
  loadStatus: false,
  // Global full-page loader state for route changes
  isRouteLoading: false,
  // Id of the post currently targeted by the report-post flow
  reportId: null,
  // Whether the compose box is currently in "reply" mode
  isReply: false,
  // Status flag surfaced while a reply is being posted
  replyPostStatus: [],
  // Total count paired with the last-fetched paginated collection (replies/reposts/posts)
  totalCountPosts: null,
  allFollowPosts: [],
  repliesCount: 0,
  // Current text typed into the global search box
  searchText: '',
  // Results of the last fetchSearchResults action, grouped by entity type
  searchResults: {
  users: [],
  posts: [],
  groups: [],
  },
  // Posts fetched for the "unread" notifications/feed surface
  unreadPosts: [],
  // Non-null (the original query) when the last search returned nothing
  noSearchResults: null,
  // Intro/onboarding posts shown to new users
  introPosts: [],
  // Ids removed via deletePost, tracked so lingering UI references can be filtered client-side
  deletedPostIds: [],
});
